import React, { useCallback } from 'react';
import { PersistentTooltip } from './Tooltip';
import { TooltipIcon } from './icons/TooltipIcon';

export const SCRIPT_SEGMENTS_TOOLTIP_ID = 'script-segments';

export const ScriptSegmentsTooltip = ({
  children,
  position = 'bottom',
  show = true,
  handleDismissTooltip,
  setLocalShowScriptSegmentsTooltip,
  style,
}) => {
  const stopPropagation = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  // Add click handler to children to clear dismissal state
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        onClick: (e) => {
          // Preserve original onClick if it exists
          if (child.props.onClick) {
            child.props.onClick(e);
          }
        },
      });
    }
    return child;
  });

  return (
    <>
      <PersistentTooltip
        style={{ ...style }}
        id={SCRIPT_SEGMENTS_TOOLTIP_ID}
        className="!w-[500px] !bg-[#101920] !p-8 !rounded-xl !z-[1001] !top-[100px] !left-[160px]"
        arrowClassName="!border-b-[#101920]"
        content={
          <div
            onClick={stopPropagation}
            onMouseDown={stopPropagation}
            onTouchStart={stopPropagation}
            className="flex flex-col gap-2 text-white"
          >
            <p className="font-roboto flex gap-2 items-center text-lg font-semibold">
              <div className="relative inline-flex items-center">
                <div className="pulse-icon">
                  <TooltipIcon className="relative" />
                </div>
              </div>{' '}
              Break Into Segments
            </p>
            <div className="h-[0.5px] bg-[#676669] w-full" />
            <div className="flex flex-col font-roboto text-sm">
              <p>Split your script into 10–15 second chunks.</p>
              <p>Add a blank line between each to create a new segment.</p>
            </div>
          </div>
        }
        position={position}
        show={show}
        onOutsideClick={() => {
          handleDismissTooltip(
            SCRIPT_SEGMENTS_TOOLTIP_ID,
            setLocalShowScriptSegmentsTooltip
          );
        }}
        onDismiss={() => {
          handleDismissTooltip(
            SCRIPT_SEGMENTS_TOOLTIP_ID,
            setLocalShowScriptSegmentsTooltip
          );
        }}
      >
        {childrenWithProps}
      </PersistentTooltip>
    </>
  );
};
